import React from 'react';

const LinkIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2593_180)">
      <path
        d="M0.125 7.75C0.125 5.34375 2.06641 3.375 4.5 3.375H6.6875C6.90625 3.375 7.125 3.59375 7.125 3.8125C7.125 4.05859 6.90625 4.25 6.6875 4.25H4.5C2.55859 4.25 1 5.83594 1 7.75C1 9.69141 2.55859 11.25 4.5 11.25H6.6875C6.90625 11.25 7.125 11.4688 7.125 11.6875C7.125 11.9336 6.90625 12.125 6.6875 12.125H4.5C2.06641 12.125 0.125 10.1836 0.125 7.75ZM15.875 7.75C15.875 10.1836 13.9062 12.125 11.5 12.125H9.3125C9.06641 12.125 8.875 11.9336 8.875 11.6875C8.875 11.4688 9.06641 11.25 9.3125 11.25H11.5C13.4141 11.25 15 9.69141 15 7.75C15 5.83594 13.4141 4.25 11.5 4.25H9.3125C9.06641 4.25 8.875 4.05859 8.875 3.8125C8.875 3.59375 9.06641 3.375 9.3125 3.375H11.5C13.9062 3.375 15.875 5.34375 15.875 7.75ZM4.28125 7.3125H11.7188C11.9375 7.3125 12.1562 7.53125 12.1562 7.75C12.1562 7.99609 11.9375 8.1875 11.7188 8.1875H4.28125C4.03516 8.1875 3.84375 7.99609 3.84375 7.75C3.84375 7.53125 4.03516 7.3125 4.28125 7.3125Z"
        // fill="#1F1F1F"
      />
    </g>
    <defs>
      <clipPath id="clip0_2593_180">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default LinkIcon;
